import { api } from "@/lib/api";

export interface Site {
  id: string;
  code: string;
  name: string;
  description: string | null;
  is_active: boolean;
  customer_count: number;
}

export interface SiteBody {
  name: string;
  description?: string | null;
}

export function listSites(): Promise<Site[]> {
  return api.get<Site[]>("/sites");
}

export function createSite(body: SiteBody): Promise<Site> {
  return api.post<Site>("/sites", body);
}

export function updateSite(
  id: string,
  body: Partial<SiteBody> & { is_active?: boolean },
): Promise<Site> {
  return api.patch<Site>(`/sites/${id}`, body);
}

export function deleteSite(id: string): Promise<{ message: string }> {
  return api.delete<{ message: string }>(`/sites/${id}`);
}
